import { useTranslation } from 'react-i18next';
import { uomKg, EnergieProductGroup } from '../Config/constants';
import { productionOrderStates as state } from '../Config/productionOrderStates'
import { scissorTypes } from '../Config/scissorStates'

export function GetOrderPaletInfoForOrderDetailInfoTable(BOMOut) {
    const { t } = useTranslation();

    const rows = [
        createData(t('N° of palets'), BOMOut),
        createData(t('Pieces per palet'), BOMOut.quantityOnCarrier),
        createData(t('To be created'), BOMOut.quantityToProduce),
        createData(t('Quality'), BOMOut.productMetaData)
    ];


    function createData(name, info) {
        if (name === t('N° of palets')) {
            info = Math.ceil(info.quantityToProduce / info.quantityOnCarrier)
        }

        if (name === t('Quality')) {
            info = JSON.parse(info)
            info = info.find(x => x.MetaDataType === 2)
            info = info.MetaData[0].Quality
        }

        return { name, info };
    }

    return rows
}

export function GetOrderPaletInfoForOrderInfoTable(BOMOut, admin, currentSilo, productionOrder) {
    const { t } = useTranslation();
    var rows = [];
    var numberOfPallets = Math.ceil(BOMOut.quantityToProduce / BOMOut.quantityOnCarrier);
    var palletsOk = true;
    var palletTooltip = t('N° of palets');

    if (productionOrder.palletsFromCarpentry) {
        if (numberOfPallets > productionOrder.palletsAvailable) {
            palletsOk = false;
            palletTooltip = t('Palletten nog niet beschikbaar uit Schrijnwerkerij');
        } else {
            palletTooltip = t('Palletten beschikbaar uit Schrijnwerkerij')
        }
        numberOfPallets = productionOrder.palletsAvailable;
    } else {
        palletTooltip = t('Palletten beschikbaar uit magazijn');
    }

    if (admin && currentSilo !== null && currentSilo !== undefined) {
        rows = [
            createData(t('N° of palets'), numberOfPallets, palletsOk, palletTooltip),
            createData(t('Pieces per palet'), BOMOut.quantityOnCarrier, undefined, t('Pieces per palet')),
            createData(t('Pieces'), BOMOut.quantityToProduce, undefined, t('Pieces')),
            createData(t('Default silo'), currentSilo.label, undefined, t('Default silo')),
            createData(t('Silo verdeling'), (productionOrder.switchPercentage + '%'), undefined, t('Silo verdeling'))


        ];
    } else {
        rows = [
            createData(t('N° of palets'), numberOfPallets, palletsOk, palletTooltip),
            createData(t('Pieces per palet'), BOMOut.quantityOnCarrier, undefined, t('Pieces per palet')),
            createData(t('Pieces'), BOMOut.quantityToProduce, undefined, t('Pieces'))
        ];
    }

    function createData(name, info, cellOk, tooltip) {
        return { name, info, cellOk, tooltip };
    }

    return rows;
}

export function GetOrderArticleInfoForOrderDetailInfoTable(BOMOut) {
    const { t } = useTranslation();
    
    const rows = [
        createData(t('Article'), BOMOut.productName),
        createData(t('Description'), BOMOut.productDescription),
        createData(t('Dimensions'), BOMOut.productMetaData),
        createData(t('Color'), BOMOut.productMetaData)
        // createData(t('Density'), BOMOut.productMetaData)
    ];

    function createData(name, info) {

        if (name === t('Dimensions')) {
            info = JSON.parse(info)
            info = info.find(x => x.MetaDataType === 1)
            info = info.MetaData[0].Width.Value + " x " + info.MetaData[0].Length.Value + " x " + info.MetaData[0].Thickness.Value
        }

        if (name === t('Color')) {
            info = JSON.parse(info)
            info = info.find(x => x.MetaDataType === 2)
            info = info.MetaData[0].Color
        }

        if(name === t('Density')) {
            info = JSON.parse(info)
            info = info.find(x => x.MetaDataType === 1)
            info = info.MetaData[0].MassDensity.Value
        }

        return { name, info };
    }

    return rows
}

export function GetOrderArticleInfoForOrderInfoTable(BOMOut) {
    const { t } = useTranslation();

    const rows = [
        createData(t('Article'), BOMOut.productName),
        createData(t('Description'), BOMOut.productDescription),
        createData(t('Dimensions'), BOMOut.productMetaData),
        createData(t('Color'), BOMOut.productColor),
        createData(t('Quality'), BOMOut.productQuality)
    ];

    function createData(name, info) {

        if (name === t('Dimensions')) {
            info = JSON.parse(info)
            info = info.find(x => x.MetaDataType === 1)
            info = info.MetaData[0].Width.Value + " x " + info.MetaData[0].Length.Value + " x " + info.MetaData[0].Thickness.Value
        }

        return { name, info };
    }

    return rows
}

export function GetCarpentryOrderOrderLineMetaData(orderLineMetaData) {

    let metaData = JSON.parse(orderLineMetaData)
    metaData = metaData.find(x => x.MetaDataType === 3).MetaData[0]

    return metaData
}


export function getNumberOfPaletsProducedForOrder(productionOrder, props) {
    let piecesPerPallet = props.order.articles.find(x => x.id === productionOrder.article).piecesPerPallet
    return Math.ceil((parseInt(productionOrder.progress) / piecesPerPallet))
}

export function getTotalNumberOfPaletsNeededForOrder(productionOrder, props) {
    let piecesPerPallet = props.order.articles.find(x => x.id === productionOrder.article).piecesPerPallet
    return Math.ceil(parseInt(productionOrder.pieces) / piecesPerPallet)
}

export function getPiecesPerPaletForOrder(productionOrder, props) {
    return props.order.articles.find(x => x.id === productionOrder.article).piecesPerPallet
}

export function haveSameBOMIn(productionOrder1, productionOrder2) {

    let array1 = []
    let array2 = []

    var i;
    for (i = 0; i < productionOrder1.bomIn.length; i++) {
        array1.push(productionOrder1.bomIn[i].productId)
    }

    var y;
    for (y = 0; y < productionOrder2.bomIn.length; y++) {
        array2.push(productionOrder2.bomIn[y].productId)
    }

    array1 = array1.sort((a, b) => a - b)
    array2 = array2.sort((a, b) => a - b)

    if (JSON.stringify(array1) === JSON.stringify(array2)) {
        return true
    }
    else {
        return false
    }
}

export const getTotalQuantityOfBOMInMaterials = (order) => {
    let totalQuantity = 0;
    for (var bomIn of order.bomIn) {
        if (bomIn.uom === uomKg && bomIn.productGroupCode !== EnergieProductGroup) {
            totalQuantity += bomIn.quantityToConsume;
        }
    }
    return totalQuantity;
}

export function configureZonesByProductionOrderLines(orders, fetchedZones) {
    let configuredZones = [{ zone: "A", scissor: 1, used: false, orderId: null, orderRef: null },
    { zone: "B", scissor: 1, used: false, orderId: null, orderLineId: null, orderRef: null, zoneId: 0 },
    { zone: "C", scissor: 1, used: false, orderId: null, orderLineId: null, orderRef: null, zoneId: 0 },
    { zone: "D", scissor: 1, used: false, orderId: null, orderLineId: null, orderRef: null, zoneId: 0 },
    { zone: "E", scissor: 1, used: false, orderId: null, orderLineId: null, orderRef: null, zoneId: 0 },
    { zone: "F", scissor: 1, used: false, orderId: null, orderLineId: null, orderRef: null, zoneId: 0 }]

    orders = orders.filter(o => o.productionOrderStatus === state.PLANNED || o.productionOrderStatus === state.PAUSED || o.productionOrderStatus === state.RUNNING)

    let metaData = {}
    let zone = {}
    let zoneName = ""
    var o;
    for (o = 0; o < orders.length; o++) {
        if (orders[o].bowMetaData) {
            metaData = JSON.parse(orders[o].bowMetaData).find(x => x.MetaDataType === 1).MetaData[0]
            var i;
            for (i = 0; i < fetchedZones.length; i++) {
                zoneName = fetchedZones[i].name
                zone = findZone(configuredZones, zoneName)
                var y;
                for (y = 0; y < metaData.UsedZones.length; y++) {

                    if (metaData.UsedZones[y].ZoneId === fetchedZones[i].id) {
                        if (fetchedZones[i].code.includes(scissorTypes.LOWER)) {
                            zone.scissor = 0
                        }

                        zone.used = true
                        zone.orderId = orders[o].id
                        zone.orderLineId = orders[o].orderLineId
                        zone.orderRef = orders[o].reference
                    }
                }
            }
        }
    }

    return configuredZones;
}

const findZone = (zones, zoneName) => {
    for (const item of zones) {
        if (item.zone === zoneName) {
            return item
        }
    }
}

export const orderIsOnZone = (order, zone, allZones) => {

    if (order.bowMetaData) {
        return JSON.parse(order.bowMetaData).find(x => x.MetaDataType === 1).MetaData[0].UsedZones.some(y => allZones.find(z => z.id === y.ZoneId).name === zone)
    }
    else {
        return false
    }
}